import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Loader from 'components/Loader';
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types/auth';
import { hasRole, SentinelRole } from 'utils/auth';

type RoleGuardProps = GuardProps & {
  allowedRoles: SentinelRole[];
};

export default function RoleGuard({ children, allowedRoles }: RoleGuardProps) {
  const { isInitialized, isLoggedIn, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && isLoggedIn && !hasRole(user?.role, allowedRoles)) {
      navigate('/dashboard', {
        replace: true,
        state: {
          from: location.pathname
        }
      });
    }
  }, [allowedRoles, isInitialized, isLoggedIn, location.pathname, navigate, user?.role]);

  if (!isInitialized) {
    return <Loader />;
  }

  if (!isLoggedIn || !hasRole(user?.role, allowedRoles)) {
    return null;
  }

  return children;
}
